const PhoneIcon = '/assets/saopaulo/General/BusesSaoPaulo-Website-Header-PhoneIcon.svg';

const PopupIcon = '/assets/saopaulo/about/aboutus.jpg';

const BookingActive = '/assets/saopaulo/Home/BusesSaoPaulo-Website-Home-SearchBar-BuyTicket.svg';
const BookingInActive = '/assets/saopaulo/Home/BusesSaoPaulo-Website-Home-SearchBar-BuyTicket.svg';
const CancelActive = '/assets/saopaulo/Home/BusesSaoPaulo-Website-Home-SearchBar-CancelTicket.svg';
const CancelInActive = '/assets/saopaulo/Home/BusesSaoPaulo-Website-Home-SearchBar-CancelTicket.svg';
const ChangeTicket = '/assets/pullmansur/Home/Searchbar-Change ticket-icon.svg';
const ChangeTicketInActive = '/assets/pullmansur/Home/Searchbar-Change ticket-icon.svg';
const ConfirmTicket = '/assets/pullmansur/Home/Searchbar-Confirmation ticket-icon.svg';
const ConfirmTicketInActive = '/assets/pullmansur/Home/Searchbar-Confirmation ticket-icon.svg';
const Coupon = '/assets/pullmansur/Home/Searchbar-Coupon-icon.svg';

const CouponInActive = '/assets/pullmansur/Home/Searchbar-Coupon-icon.svg';
const OriginIcon =
	'/assets/pullmansur/Home/PullmandelSur-Website-Home-SearchBar-OriginIcon.png';
const DestinationIcon =
	'/assets/pullmansur/Home/PullmandelSur-Website-Home-SearchBar-DestinationIcon.png';



const CalendarIcon =
	'/assets/pullmansur/Home/PullmandelSur-Website-Home-SearchBar-CalendarIcon.png';
const pnr =
	'/assets/pullmansur/General/PullmandelSur-Website-WhereToFindMyPNR.jpg';
const SearchIcon = '/assets/pullmansur/Home/PullmandelSur-Website-Home-SearchBar-SearchIcon.svg'
const RightIcon = '/assets/pullmansur/parcel/icons/PullmandelSur-Website-HomeV2_Arrow-right.svg'
const MapIcon = '/assets/pullmansur/parcel/icons/PullmandelSur-Website-HomeV2-43.svg'
const HelloIcon = '/assets/pullmansur/parcel/icons/PullmandelSur-Website-HomeV2-44.svg'
const slidePhone = '/assets/expresonorte/offices/Offices-Telephone.svg'
// Title icons

// const titleLeftIcon = '/assets/saopaulo/General/BusesSaoPaulo-Website-Titles-Icon1.svg';
// const titleRightIcon = '/assets/saopaulo/General/BusesSaoPaulo-Website-Titles-Icon2.svg';

const ContactBg = '/assets/pullmansur/Home/PullmandelSur-Website-Home-Background-ContactSection.png';

// footerIcons

// const fb = '/assets/saopaulo/General/BusesSaoPaulo-Website-Footer-SocialMedia-Facebook.svg';
const insta = '/assets/saopaulo/General/BusesSaoPaulo-Website-Footer-SocialMedia-Instagram.svg';

// const contactFb = '/assets/pullmansur/Contact/PullmandelSur-Website-Contact-SocialMedia-Facebook.png';
const contactInsta =
	'/assets/pullmansur/Contact/PullmandelSur-Website-Contact-SocialMedia-Instagram.png';

// banners
const ParcelBanner =
	'/assets/pullmansur/Home/PullmandelSur-Website-Home-BannerEncomiendas-01.webp';
const destinationBanner =
	'/assets/pullmansur/Destinations/PullmandelSur-Website-Destinations-Banner.png';
const contactUsBanner = '/assets/pullmansur/Contact/PullmandelSur-Website-Contact-Banner.png';
const aboutUsBanner = '/assets/pullmansur/company/PullmandelSur-Website-TheCompany-Banner.png';
const tncBanner = '/assets/pullmansur/tnc/PullmandelSur-Website-TermsandConditions-Banner.png';
const officeBanner = '/assets/pullmansur/Offices/PullmandelSur-Website-Offices-Banner.png';
// const aboutUsSecondBanner =
//   '/assets/pullmansur/company/PullmandelSur-Website-TheCompany-BannerHistory.png';

const aboutUsImage = '/assets/pullmansur/company/PullmandelSur-Website-TheCompany-AboutUs.jpg';

const contactMail = '/assets/pullmansur/Contact/PullmandelSur-Website-Contact-Email-Icon.png';
const contactHeadphone =
	'/assets/pullmansur/Offices/PullmandelSur-Website-Offices-PhoneNumber-Icon.png';

const pin = '/assets/pullmansur/Offices/PullmandelSur-Website-Offices-Pin-Icon.png';
const checkboxIcon = '/static/images/icons/BusOperatorsWebsite-Checkbox.png';
const animation = '/static/images/animations/Services-kupos-PasajeBus-Orange.gif';


// gray icons section 
const success = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-CheckMark-Gray.svg';
const failure = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-Information-Gray.svg';
const tick = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-Tick-Gray.svg';
const heartOn = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-HeartOn-Gray.svg';
const heartOff = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-HeartOff-Gray.svg';
const downArrow = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-DropDown-Gray.svg';
const registrationSuccess = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-RightDocument-Gray.svg';
const userIcon = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-Login-Gray.svg';
const trips = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-MyTrips-Gray.svg';
const cards = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-MyCards-Gray.svg';
const wallet = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-RechargeWallet-Gray.svg';
const transaction = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-ShareMoney-Gray.svg';
const otp = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-RestorePassword-Gray.svg';
const paso_1 = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-RechargeWallet-Gray.svg';
const paso_2 = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-RechargePoints-Gray.svg';
const paso_3 = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-ID-Gray.svg';
const paso_4 = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-Tickets-Gray.svg';
const operatorPay = '/assets/pullmansur/General/pullman-del-sur-pay.png';
const pullmandelsurIcons = [
	// gray icons section 

	{ icon: operatorPay, name: 'operatorPay' },
	{ icon: MapIcon, name: 'Destination' },
	{ icon: HelloIcon, name: 'TelephoneIcon' },
	{ icon: RightIcon, name: 'BlueArrow' },
	{ icon: downArrow, name: 'downArrow' },
	{ icon: userIcon, name: 'userIcon' },
	{ icon: trips, name: 'trips' },
	{ icon: cards, name: 'cards' },
	{ icon: wallet, name: 'wallet' },
	{ icon: transaction, name: 'transaction' },
	{ icon: success, name: 'success' },
	{ icon: failure, name: 'failure' },
	{ icon: tick, name: 'tick' },
	{ icon: heartOn, name: 'heartOn' },
	{ icon: heartOff, name: 'heartOff' },
	{ icon: registrationSuccess, name: 'registrationSuccess' },
	{ icon: otp, name: 'otp' },
	{ icon: paso_1, name: 'paso_1' },
	{ icon: paso_2, name: 'paso_2' },
	{ icon: paso_3, name: 'paso_3' },
	{ icon: paso_4, name: 'paso_4' },

	{ icon: PopupIcon, name: 'Popup' },
	{ icon: PhoneIcon, name: 'phone' },
	{ icon: BookingActive, name: 'BA' },
	{ icon: BookingInActive, name: 'BIA' },
	{ icon: CancelActive, name: 'CA' },
	{ icon: CancelInActive, name: 'CIA' },
	{ icon: ChangeTicket, name: 'CTA' },
	{ icon: ChangeTicketInActive, name: 'CTIA' },
	{ icon: ConfirmTicket, name: 'CCA' },
	{ icon: ConfirmTicketInActive, name: 'CCIA' },
	{ icon: Coupon, name: 'CUA' },
	{ icon: CouponInActive, name: 'CUIA' },
	{ icon: OriginIcon, name: 'Origin' },
	{ icon: DestinationIcon, name: 'Destination' },
	{ icon: CalendarIcon, name: 'Calendar' },
	{ icon: pnr, name: 'pnr' },
	{ icon: slidePhone, name: 'TelephoneIcon' },

	// Title icons
	// { icon: titleLeftIcon, name: 'titleLeftIcon' },
	// { icon: titleRightIcon, name: 'titleRightIcon' },

	{ icon: ContactBg, name: 'ContactBg' },

	// footerIcons
	// { icon: fb, name: 'fb' },
	{ icon: insta, name: 'insta' },

	// { icon: contactFb, name: 'contactFb' },
	{ icon: contactInsta, name: 'contactInsta' },




	{ icon: ParcelBanner, name: 'ParcelBanner' },
	{ icon: destinationBanner, name: 'destinationBanner' },
	{ icon: contactUsBanner, name: 'contactUsBanner' },
	{ icon: aboutUsBanner, name: 'aboutUsBanner' },
	{ icon: tncBanner, name: 'tncBanner' },
	{ icon: officeBanner, name: 'officeBanner' },
	// { icon: aboutUsSecondBanner, name: 'aboutUsSecondBanner' },

	{ icon: contactMail, name: 'contactMail' },
	{ icon: contactHeadphone, name: 'contactHeadphone' },

	{ icon: aboutUsImage, name: 'aboutUsImage' },

	{ icon: checkboxIcon, name: 'Checkbox' },
	{ icon: animation, name: 'animation' },
	{ icon: pin, name: 'pin' },
	{ icon: SearchIcon, name: 'Search' },

];

export default pullmandelsurIcons;



// WEBPACK FOOTER //
// ./src/features/themes/functions/getIcons/pullmandelsurIcons.js